import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'

const FETCH_REPORT_REQUEST = 'Reports/FETCH_REPORT_REQUEST'
const FETCH_REPORT_SUCCESS = 'Reports/FETCH_REPORT_SUCCESS'
const FETCH_REPORT_FAILURE = 'Reports/FETCH_REPORT_FAILURE'

const FETCH_HERO_TRANSACTION_REQUEST = 'Reports/FETCH_HERO_TRANSACTION_REQUEST'
const FETCH_HERO_TRANSACTION_SUCCESS = 'Reports/FETCH_HERO_TRANSACTION_SUCCESS'
const FETCH_HERO_TRANSACTION_FAILURE = 'Reports/FETCH_HERO_TRANSACTION_FAILURE'

const FETCH_ALL_REPORT_REQUEST = 'Reports/FETCH_ALL_REPORT_REQUEST'
const FETCH_ALL_REPORT_SUCCESS = 'Reports/FETCH_ALL_REPORT_SUCCESS'
const FETCH_ALL_REPORT_FAILURE = 'Reports/FETCH_ALL_REPORT_FAILURE'

const FETCH_ALL_HERO_TRANSACTION_REQUEST = 'Reports/FETCH_ALL_HERO_TRANSACTION_REQUEST'
const FETCH_ALL_HERO_TRANSACTION_SUCCESS = 'Reports/FETCH_ALL_HERO_TRANSACTION_SUCCESS'
const FETCH_ALL_HERO_TRANSACTION_FAILURE = 'Reports/FETCH_ALL_HERO_TRANSACTION_FAILURE'
// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  transactionList: [],
  heroList: [],
  allTransactionList: [],
  allHeroList: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transactionList: action.payload
      }
    case FETCH_REPORT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_HERO_TRANSACTION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroList: action.payload
      }
    case FETCH_HERO_TRANSACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }   
    case FETCH_ALL_REPORT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_REPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        allTransactionList: action.payload
      }
    case FETCH_ALL_REPORT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_ALL_HERO_TRANSACTION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_HERO_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        allHeroList: action.payload
      }
    case FETCH_ALL_HERO_TRANSACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

// Action Creators
export const fetchBinReport = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_REPORT_REQUEST
      })

      const response = await API.get(EndPoints.BIN + `/transaction-admin`, {
        params: options
      })

      dispatch({
        type: FETCH_REPORT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_REPORT_FAILURE
      })
    }
  }
}

export const fetchHeroReport = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_TRANSACTION_REQUEST
      })

      const response = await API.get(EndPoints.BIN + `/hero-transaction`)

      dispatch({
        type: FETCH_HERO_TRANSACTION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_TRANSACTION_FAILURE
      })
    }
  }
}
export const fetchAllBinReport = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALL_REPORT_REQUEST
      })

      const response = await API.get(EndPoints.BIN + `/transaction-admin-all`, {
        params: options
      })

      dispatch({
        type: FETCH_ALL_REPORT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_ALL_REPORT_FAILURE
      })
    }
  }
}

export const fetchAllHeroReport = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ALL_HERO_TRANSACTION_REQUEST
      })

      const response = await API.get(EndPoints.BIN + `/hero-transaction-all`)

      dispatch({
        type: FETCH_ALL_HERO_TRANSACTION_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_ALL_HERO_TRANSACTION_FAILURE
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/modules/reports.js